import { render, staticRenderFns } from "./ArticleMagazine0013.vue?vue&type=template&id=6cf12c17&scoped=true&"
import script from "./ArticleMagazine0013.vue?vue&type=script&lang=js&"
export * from "./ArticleMagazine0013.vue?vue&type=script&lang=js&"
import style0 from "./ArticleMagazine0013.vue?vue&type=style&index=0&id=6cf12c17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf12c17",
  null
  
)

export default component.exports